export default __webpack_public_path__ + "static/media/template_folder.0bf02bed.svg";